<template>
    <div v-if='portalUserId' v-cloak>
        <AGISHeader :userManagementVisible='false'/>
        <div>
            <main>
                <router-view></router-view>
                <p class="mt-3 mb-2 copy-right" style="color:white">&copy; Airport Authority Hong Kong. All Rights Reserved.</p>
            </main>
            <aside>
            </aside>
        </div>
    </div>
</template>

<script>
import PortalAuth from '@/service/portalAuth';
import AGISHeader from '@/components/ui-components/AGISHeader';

export default {
  name: 'home-layout',
  components: {
      AGISHeader
  },
  created: function () {
      this.portalUserId = this.$root.$refs.app.portalUserId;
  },
  data:function(){
      return {
            portalUserId: null,
            image: "static/aa_background_1_update.jpg",
            baseUrl : process.env.__APP_BASE_PATH__
      }
  },
  mounted:function() {
        this.image = this.baseUrl + this.image;
  },
  methods:{
      logout: function(){ 
        var portalAuth = new PortalAuth();
        portalAuth.logout(this.$router);
      },
      initMask:function(){
        this.classList = "mask mark-initial"
      },
      opening:function(){
        var intervalAtOnce = true;
        var intervalId = setInterval(()=>{ 
            if(intervalAtOnce){
                this.classList = "mask mark-complete"
                intervalAtOnce=false;
                window.clearInterval(intervalId);
            }
        },1000)
      }
  }
}
</script>

<style>
[v-cloak] {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/account/Layout.vue